function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { parse as parseDate } from '@citation-js/date';
import { parse as parseName } from '@citation-js/name';

function nameProps(person) {
  var firstname = person.firstname,
      lastname = person.lastname,
      _person$firstName = person.firstName,
      given = _person$firstName === void 0 ? firstname : _person$firstName,
      _person$lastName = person.lastName,
      family = _person$lastName === void 0 ? lastname : _person$lastName;

  if (given && family) {
    return {
      given: given,
      family: family
    };
  } else if (person.name) {
    return parseName(person.name);
  }
}

var identifiers = ['PMID', 'PMCID', 'DOI', 'ISBN'];
var journalIdentifiers = ['ISSN'];

function idProps(input, identifiers) {
  var output = {};

  for (var prop in input) {
    var upperCaseProp = prop.toUpperCase();

    if (identifiers.includes(upperCaseProp)) {
      output[upperCaseProp] = input[prop];
    }
  }

  if (input.identifier) {
    var _iterator = _createForOfIteratorHelper(input.identifier),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _step.value,
            id = _step$value.id,
            _step$value$type = _step$value.type,
            type = _step$value$type === void 0 ? '' : _step$value$type;
        type = type.toUpperCase();

        if (identifiers.includes(type)) {
          output[type] = id;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return output;
}

var typeMap = {
  article: 'article',
  book: 'book',
  booklet: 'book',
  proceedings: 'book',
  mastersthesis: 'thesis',
  inbook: 'chapter',
  incollection: 'chapter',
  conference: 'paper-conference',
  inproceedings: 'paper-conference',
  online: 'website',
  patent: 'patent',
  phdthesis: 'thesis',
  techreport: 'report',
  unpublished: 'manuscript',
  manual: undefined,
  misc: undefined
};

function quickscrapeSpecificProps() {
  return {
    type: 'article-journal'
  };
}

function generalProps(input) {
  var output = {
    type: typeMap[input.type] || 'book'
  };

  if (input.title) {
    output.title = input.title;
  }

  if (input.author) {
    output.author = input.author.map(nameProps).filter(Boolean);
  }

  if (input.editor) {
    output.editor = input.editor.map(nameProps).filter(Boolean);
  }

  if (input.reviewer) {
    if (input.author) {
      output['reviewed-author'] = output.author;
    }

    output.author = input.reviewer.map(nameProps).filter(Boolean);
  }

  if (Array.isArray(input.keywords)) {
    output.keyword = input.keywords.join();
  } else if (input.keywords) {
    output.keyword = input.keywords;
  }

  if (input.publisher) {
    output.publisher = input.publisher.name || input.publisher;
  }

  if (input.date && Object.keys(input.date).length > 0) {
    var dates = input.date;

    if (dates.submitted) {
      output.submitted = parseDate(dates.submitted);
    }

    if (dates.published) {
      output.issued = parseDate(dates.published);
    }
  } else if (input.year) {
    output.issued = {
      'date-parts': [[+input.year]]
    };
  }

  if (input.journal) {
    var journal = input.journal;

    if (journal.name) {
      output['container-title'] = journal.name;
    }

    if (journal.volume) {
      output.volume = +journal.volume;
    }

    if (journal.issue) {
      output.issue = +journal.issue;
    }

    Object.assign(output, idProps(journal, journalIdentifiers));

    if (journal.firstpage) {
      output['page-first'] = journal.firstpage;
    }

    if (journal.pages) {
      output.page = journal.pages.replace('--', '-');
    } else if (journal.firstpage && journal.lastpage) {
      output.page = journal.firstpage + '-' + journal.lastpage;
    }
  }

  if (input.link && typeof input.link[0] === 'object') {
    output.URL = input.link[0].url;
  }

  Object.assign(output, idProps(input, identifiers));

  if (input.cid) {
    output.id = input.cid;
  } else if (output.DOI) {
    output.id = output.DOI;
  }

  return output;
}

var parseContentMine = function parseContentMine(data) {
  return Object.assign(generalProps(data), quickscrapeSpecificProps(data));
};

var parseBibJson = function parseBibJson(data) {
  return generalProps(data);
};

export { parseContentMine as quickscrapeRecord, parseBibJson as record };